import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const entityOutletStyleId = 'entity-outlet-theme';

/**
 * Inline cover sits above the dashboard board. AG Grid 36 pins the header in
 * `.ag-grid-pinned-top-rows` at sticky z-index 2, so a transparent z-index 1
 * cover lets that header and the grid scrollbar paint through the manage page.
 */
export const entityOutletBridgeStyles = {
  'entity-outlet.entity-outlet-open.entity-outlet-inline': {
    '--local-outlet-cover-bg': tokens.color.background.primary,
    '--local-outlet-cover-z': '20',
  },
};
